"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var InfoCircleOutline_1 = __importDefault(require("../icons/generated/InfoCircleOutline"));
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n"], ["\n  position: relative;\n  cursor: pointer;\n"])));
exports.ContentWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 200;\n  background-color: ", ";\n  color: ", ";\n  margin-top: 10px;\n  max-width: 250px;\n  right: 100%;\n  top: -15px;\n  margin-right: 15px;\n  font-size: 14px;\n  padding: ", ";\n  text-align: ", ";\n  min-width: 200px;\n"], ["\n  position: absolute;\n  z-index: 200;\n  background-color: ",
    ";\n  color: ",
    ";\n  margin-top: 10px;\n  max-width: 250px;\n  right: 100%;\n  top: -15px;\n  margin-right: 15px;\n  font-size: 14px;\n  padding: ", ";\n  text-align: ", ";\n  min-width: 200px;\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.backgroundColor;
}, function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.textColor;
}, function (_a) {
    var small = _a.small;
    return (small ? '11px' : '17px');
}, function (_a) {
    var centeredText = _a.centeredText;
    return (centeredText ? 'center' : 'unset');
});
exports.Arrow = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 10px solid\n    ", ";\n  position: absolute;\n  top: 10px;\n  margin-left: -5px;\n  right: -10px;\n"], ["\n  width: 0;\n  height: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 10px solid\n    ",
    ";\n  position: absolute;\n  top: 10px;\n  margin-left: -5px;\n  right: -10px;\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.backgroundColor;
});
exports.Icon = styled_components_1.default(InfoCircleOutline_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  fill: ", ";\n"], ["\n  width: 20px;\n  height: 20px;\n  fill: ",
    ";\n"])), function (_a) {
    var tooltip = _a.theme.colours.tooltip;
    return tooltip.iconColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=tooltip.style.js.map